<template>
  <div>
    <div><!-- display: flex;justify-content: space-between; -->
      <div>
        <el-form :inline="true" style="text-align:right;">
          <el-form-item :label='$t("time.timeQuery")' class="selectIcon">
            <el-select v-model="searchType" style="width:140px" :size="size">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-show="searchShow && activeName == 'first'">
            <el-date-picker :size="size" style="width:295px" v-model="searchMTime" type="monthrange"
              value-format="yyyy-MM" :picker-options="monthPickerOptions" :range-separator='$t("time.to")'
              :start-placeholder='$t("time.startMonth")' :end-placeholder='$t("time.endMonth")'>
            </el-date-picker><!-- unlink-panels  -->
          </el-form-item>
          <el-form-item v-show="searchShow && activeName == 'second'">
            <el-date-picker :size="size" style="width:305px" v-model="searchDTime" type="daterange"
              :picker-options="datePickerOptions" :range-separator='$t("time.to")'
              :start-placeholder='$t("time.startDate")' :end-placeholder='$t("time.endDate")'>
            </el-date-picker>
          </el-form-item>
          <el-form-item v-if="searchShow">
            <el-button type="primary" plain :size="size" style="margin-left:15px;" @click="handleQuery">{{
              $t("public.query")}}</el-button>
          </el-form-item>
          <el-form-item v-if="!searchShow && activeName == 'first'">
            <el-button v-for="item in monthBtns" :key="item.value" :type="showMBtn == item.value ? 'primary' : ''"
              :size="size" style="text-align:center;" @click="quickQuery(item.value)">{{ item.label }}</el-button>
          </el-form-item>
          <el-form-item v-if="!searchShow && activeName == 'second'">
            <el-button v-for="item in dayBtns" :key="item.value" :type="showDBtn == item.value ? 'primary' : ''"
              :size="size" style="text-align:center;" @click="quickQuery(item.value)">{{ item.label }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button :size="size" type="primary" style="margin-left:10px" @click="download" :loading="downloading">{{
              $t("public.download")}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div style="height: calc(100vh - 245px);overflow: auto;padding-top:10px">
      <div style="padding:0 8px;"> <!-- height:calc(100vh - 143px); -->
        <div>
          <!-- 电车统计 -->
          <div v-show="chartAllOrSingle && exist_power_oil.isPower_Cpn">
            <el-row :gutter="15">
              <el-col :span="8">
                <el-card class="card" style="padding:0 8px" shadow="hover">
                  <div slot="header">
                    <div style="display: flex;">
                      <div style="">
                        <span class="comptVal">{{ fleetConspt }}</span>
                        <span style="font-size:12px">kW·h</span>
                      </div>
                      <div style="flex:1;text-align:right">
                        <!-- <span class="pcVal" >8.9%</span>
                        <i class="el-icon-top" style="color:red,font-size:24px"></i> -->
                      </div>
                    </div>
                    <div
                      style="margin-top: 5px;color: #303133;opacity: 0.7; font-size:12px; display: flex; justify-content: space-between">
                      <span>{{ $t("statistics.fleetConspt") }}</span>
                      <!-- <span>环比</span> -->
                    </div>
                  </div>
                  <div class="carBody" style="text-align:center">
                    <div v-loading="loadingCharts" :id="'chart_fleetConspt' + type" style="width: 100%;height: 150px;">
                    </div>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="8">
                <el-card class="card" style="padding:0 8px" shadow="hover">
                  <div slot="header">
                    <div style="display: flex;">
                      <div style="">
                        <span class="comptVal">{{ fleetMileage }}</span>
                        <span style="font-size:12px">km</span>
                      </div>
                      <div style="flex:1;text-align:right">
                        <!-- <span class="pcVal" >8.9%</span>
                        <i class="el-icon-top" style="color:red,font-size:24px"></i> -->
                      </div>
                    </div>
                    <div
                      style="margin-top: 5px;color: #303133;opacity: 0.7; font-size:12px; display: flex; justify-content: space-between">
                      <span>{{ $t("statistics.fleetMileage") }}</span>
                      <!-- <span>环比</span> -->
                    </div>
                  </div>
                  <div class="carBody" style="text-align:center">
                    <div v-loading="loadingCharts" :id="'chart_fleetMileage' + type" style="width: 100%;height: 150px;">
                    </div>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="8">
                <el-card class="card" style="padding:0 8px" shadow="hover">
                  <div slot="header">
                    <div style="display: flex;">
                      <div style="">
                        <span class="comptVal">{{ avgConspt }}</span>
                        <span style="font-size:12px">kW·h/100km</span>
                      </div>
                      <div style="flex:1;text-align:right">
                        <!-- <span class="pcVal" style="font-size:15px;">8.9%</span>
                        <i class="el-icon-top" style="color:red,font-size:24px"></i> -->
                      </div>
                    </div>
                    <div
                      style="margin-top: 5px;color: #303133;opacity: 0.7; font-size:12px; display: flex; justify-content: space-between">
                      <span>{{ $t("statistics.avgConspt") }}</span>
                      <!-- <span>环比</span> -->
                    </div>
                  </div>
                  <div class="carBody" style="text-align:center">
                    <div v-loading="loadingCharts" :id="'chart_avgConspt' + type" style="width: 100%;height: 150px;">
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </div>
          <!-- 油车统计 -->
          <div v-show="chartAllOrSingle && exist_power_oil.isOil_Cpn" style="margin-top:8px">
            <el-row :gutter="15">
              <el-col :span="8">
                <el-card class="card" style="padding:0 8px" shadow="hover">
                  <div slot="header">
                    <div style="display: flex;">
                      <div style="">
                        <span class="comptVal">{{ fleetOilConspt }}</span>
                        <span style="font-size:12px">L·h</span>
                      </div>
                      <div style="flex:1;text-align:right">
                        <!-- <span class="pcVal" >8.9%</span>
                        <i class="el-icon-top" style="color:red,font-size:24px"></i> -->
                      </div>
                    </div>
                    <div
                      style="margin-top: 5px;color: #303133;opacity: 0.7; font-size:12px; display: flex; justify-content: space-between">
                      <span>{{ $t("statistics.fleetOilConspt") }}</span>
                      <!-- <span>环比</span> -->
                    </div>
                  </div>
                  <div class="carBody" style="text-align:center">
                    <div v-loading="loadingCharts" :id="'chart_fleetOilConspt' + type" style="width: 100%;height: 150px;">
                    </div>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="8">
                <el-card class="card" style="padding:0 8px" shadow="hover">
                  <div slot="header">
                    <div style="display: flex;">
                      <div style="">
                        <span class="comptVal">{{ fleetOilMileage }}</span>
                        <span style="font-size:12px">km</span>
                      </div>
                      <div style="flex:1;text-align:right">
                        <!-- <span class="pcVal" >8.9%</span>
                        <i class="el-icon-top" style="color:red,font-size:24px"></i> -->
                      </div>
                    </div>
                    <div
                      style="margin-top: 5px;color: #303133;opacity: 0.7; font-size:12px; display: flex; justify-content: space-between">
                      <span>{{ $t("statistics.fleetOilMileage") }}</span>
                      <!-- <span>环比</span> -->
                    </div>
                  </div>
                  <div class="carBody" style="text-align:center">
                    <div v-loading="loadingCharts" :id="'chart_fleetOilMileage' + type"
                      style="width: 100%;height: 150px;"></div>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="8">
                <el-card class="card" style="padding:0 8px" shadow="hover">
                  <div slot="header">
                    <div style="display: flex;">
                      <div style="">
                        <span class="comptVal">{{ avgOilConspt }}</span>
                        <span style="font-size:12px">L·h/100km</span>
                      </div>
                      <div style="flex:1;text-align:right">
                        <!-- <span class="pcVal" style="font-size:15px;">8.9%</span>
                        <i class="el-icon-top" style="color:red,font-size:24px"></i> -->
                      </div>
                    </div>
                    <div
                      style="margin-top: 5px;color: #303133;opacity: 0.7; font-size:12px; display: flex; justify-content: space-between">
                      <span>{{ $t("statistics.avgOilConspt") }}</span>
                      <!-- <span>环比</span> -->
                    </div>
                  </div>
                  <div class="carBody" style="text-align:center">
                    <div v-loading="loadingCharts" :id="'chart_avgOilConspt' + type" style="width: 100%;height: 150px;">
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </div>
          <div v-show="!chartAllOrSingle && exist_power_oil.isPower">
            <div :id="'chart_single_power' + type" v-loading="loading" style="width: 100%;height: 215px;"></div>
          </div>
          <div v-show="!chartAllOrSingle && exist_power_oil.isOil" style="margin-top:8px">
            <div :id="'chart_single_oil' + type" v-loading="loading" style="width: 100%;height: 215px;"></div>
          </div>

          <!-- <div style="margin:5px 0;border: 1px solid #C5D0E2;border-radius: 4px;padding:8px 15px 8px 15px;"> 
            <div style="display:flex">
              <div class="page_title" style="padding: 7px 0;">
                <span >能耗统计</span>
              </div>
              <div style="flex:1;text-align:right">
                <div>
                  <el-radio-group v-model="radio1" size="mini" @input="StatisticalMethod">
                    <el-radio-button label="总计"></el-radio-button>
                    <el-radio-button label="平均"></el-radio-button>
                  </el-radio-group>
                </div>
              </div>
              <div style="text-align:right;margin-left:10px">
                <el-radio-group v-model="radio2" size="mini" @input="report">
                  <el-radio-button label="小时"></el-radio-button>
                  <el-radio-button label="日报"></el-radio-button>
                  <el-radio-button label="周报" ></el-radio-button>  
                  <el-radio-button label="月报" ></el-radio-button>
                </el-radio-group>
              </div>
              <div style="text-align:right;margin-left:10px">
                <el-button size="mini" type="primary" plain @click="fold" class="foldBtn">
                  折叠 
                  <span class="iconfont" v-if="showChartConspt">&#xe6f3;</span>
                  <span class="iconfont" v-else>&#xe6f1;</span>
                </el-button>
              </div>
            </div>
            <div id="chart_conspt" style="width:100%;height:200px;text-align:center" v-show="showChartConspt"></div>
          </div> -->

        </div>
        <div class="container" style="margin-top:8px">
          <!--:style="{'height':height}"  calc(100vh - 565px) calc(100vh - 765px)  :height="height"-->
          <el-table :size="size" :data="isAllVehicles ? dataList : list" @sort-change='sortChange' border
            v-loading="loading" ref="table">
            <el-table-column :label='$t("public.OrderIndex")' width="105" align="center" prop="id"
              :key="1"></el-table-column>
            <el-table-column :label='$t("vehicle.carNo")' align="center" prop="carNo" :min-width="170" sortable="custom"
              :key="2"></el-table-column>
            <el-table-column :label='$t("vehicle.ManufactureNo")' align="center" prop="manufactureNo" :min-width="115"
              :key="3"></el-table-column>
            <el-table-column :label='$t("statistics.fuelType")' align="center" prop="fuelType" :min-width="110"
              :key="4">
              <template slot-scope="scope">{{ fuelTypeLanguages(scope.row) }}</template>
            </el-table-column>
            <el-table-column :label='$t("statistics.statisticalTime")' align="center" prop="statisticalTime"
              :min-width="127" sortable="custom" :key="5"></el-table-column>
            <el-table-column :label='$t("statistics.runTime")' align="center" prop="runTime" :min-width="130"
              sortable="custom" :key="6">
              <template slot-scope="scope">{{ timeChange(scope.row.runTime) }}</template>
            </el-table-column>
            <el-table-column :label='$t("statistics.utilization")' align="center" prop="utilization" :min-width="110"
              sortable="custom" :key="7">
              <template slot-scope="scope">{{ scope.row.utilization ? scope.row.utilization == 0 ? scope.row.utilization
                : scope.row.utilization + "%" : 0}}</template>
            </el-table-column>
            <el-table-column :label='$t("statistics.mileage")' :min-width="140" align="center" prop="mileage"
              sortable="custom" :key="8">
              <template slot-scope="scope">{{ Number(scope.row.mileage.toFixed(2)) }}</template>
            </el-table-column>
            <el-table-column :label='$t("statistics.powerConsumption")' align="center" :min-width="195"
              prop="powerConsumption" sortable="custom" :key="9">
              <template slot-scope="scope">
                <!-- {{scope.row.powerConsumption}} -->
                {{ setNullForOil(scope.row, scope.row.powerConsumption) }}
              </template>
            </el-table-column>
            <el-table-column :label='$t("statistics.powerConsumptionPer100km")' align="center" :min-width="200"
              prop="powerConsumptionPer100km" sortable="custom" :key="10">
              <template slot-scope="scope">

                {{ setNullForOil(scope.row, scope.row.powerConsumptionPer100km) }}
              </template>
              <!-- <template slot-scope="scope">
                {{(scope.row.powerConsumptionPer100km).toFixed(2)}}
              </template> -->
            </el-table-column>
            <el-table-column :label="$t('statistics.oilConsume')" align="center" :min-width="195" prop="oilConsumption"
              sortable="custom" :key="11">
              <template slot-scope="scope">
                <!-- {{scope.row.oilConsumption}} -->
                {{ setNullForEle(scope.row, scope.row.oilConsumption) }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('runState.perOilConsume')" align="center" :min-width="200"
              prop="oilConsumptionPer100km" sortable="custom" :key="12">
              <template slot-scope="scope">
                <!-- {{(scope.row.oilConsumptionPer100km)}} -->
                {{ setNullForEle(scope.row, scope.row.oilConsumptionPer100km) }}
              </template>
            </el-table-column>
            <el-table-column :label='$t("statistics.avgSpeed")' :min-width="170" align="center" prop="avgSpeed"
              sortable="custom" :key="13">
              <template slot-scope="scope">
                {{ scope.row.avgSpeed }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('statistics.驱动能耗')" :min-width="115" align="center" :key="14"
              prop="MotorDriverElecQuantity"></el-table-column>
            <el-table-column :label="$t('statistics.空调能耗')" :min-width="115" align="center" :key="15"
              prop="AirConditionElecQuantity"></el-table-column>
            <el-table-column :label="$t('statistics.空压机能耗')" :min-width="125" align="center" :key="16"
              prop="BlastPumpElecQuantity"></el-table-column>
            <el-table-column :label="$t('statistics.dcdc能耗')" :min-width="125" align="center" :key="17"
              prop="DCConsumeEnergy"></el-table-column>
          </el-table>
        </div>
        <div style="text-align: right;margin-top:8px" class="pagination" v-show="total > 0"> <!--  -->
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
            layout="total, prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
// import * as echarts from "echarts"
import { mapState } from 'vuex'
import language from '@/utils/getLanguageId'
import settings from "@/settings";
export default {
  props: {
    activeName: {
      type: String,
      default: "first"
    },
    Init: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "0"
    }
  },
  data() {
    return {
      defalteQuery:{Params: "mileage",SortFlag:2},
      isAllVehicles: undefined,//标记是否查询全部车辆，因为数据分页，查询具体车辆折线图需要全部数据不能分页，用这个做标记查询是否需要分页
      allVehicles: "",//所有车辆
      chart_single_power: undefined,
      chart_single_oil: undefined,
      chartAllOrSingle: true,  //展示车队图表信息/单车图表信息
      datePickerOptions: {
        disabledDate(date) {
          return date > new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
        }
      },
      monthPickerOptions: {
        disabledDate(date) {
          var t = new Date();
          var n = new Date(t.getFullYear(), t.getMonth(), 1);

          return date > new Date(n.getTime())
        }
      },
      fleetConspt: 0,
      fleetMileage: 0,
      avgConspt: 0,
      fleetOilConspt: 0,//油车
      fleetOilMileage: 0,
      avgOilConspt: 0,
      fleetConsptChartData: 0,
      fleetMileageChartData: 0,
      avgConsptChartData: 0,
      fleetOilConsptChartData: 0,//油车
      fleetOilMileageChartData: 0,
      avgOilConsptChartData: 0,
      // winHeight:undefined,
      total: 0,
      // showChartConspt:true,
      // radio1: '总计',
      // radio2: '日报',
      chart_fleetConspt: undefined,
      chart_fleetMileage: undefined,
      chart_avgConspt: undefined,
      chart_fleetOilConspt: undefined,
      chart_fleetOilMileage: undefined,
      chart_avgOilConspt: undefined,
      // chart_conspt:undefined,
      showMBtn: undefined,
      showDBtn: undefined,
      monthBtns: [],
      dayBtns: [],
      dataList: [],
      searchDTime: [new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000), new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000)],
      searchMTime: [],
      options: [],
      beginDate: "",
      endDate: "",
      currentPage: 1,
      pageSize: 10,
      searchType: 0,
      loading: false,
      loadingCharts: false,
      autoWidth: true,
      exist_power_oil: {
        isPower: false,
        isOil: false,
        isPower_Cpn: false,
        isOil_Cpn: false
      },
      LanguageId: 1,
      Params: undefined,//排序参数  
      SortFlag: undefined,//1:升序 2:降序
      downloading: false,
    }
  },
  computed: {
    searchShow() {
      return this.searchType == 0 ? true : false;
    },
    size() {
      return this.$store.getters.size
    },
    height() {
      if (this.showChartConspt) {
        return "calc(100vh - 761px)"
      } else return "calc(100vh - 561px)"
    },
    ...mapState({
      opened: state => state.app.sidebar.opened,
      selectedVehicles: state => state.app.vehicles.selectedVehicles,
      tree: state => state.app.vehicles.tree,
      appVehicles: state => state.app.vehicles,
    }),
    list() {
      if (!this.isAllVehicles) {
        if (this.dataList != null && this.dataList.length > 0) {
          return this.dataList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
        }
      }
      return [];
    },
  },
  watch: {
    list(newVal) {
      let oil = newVal.filter((e) => {
        return e.fuelType.indexOf("油") > -1
      });
      let power = newVal.filter((e) => {
        return e.fuelType.indexOf("电") > -1 && e.fuelType.indexOf("燃料电池") == -1
      })

    },
    chartAllOrSingle(val) {
      this.$nextTick(function () {
        var myEvent = new Event("resize");
        window.dispatchEvent(myEvent);
      });
    },
    exist_power_oil: {
      handler(newval, oldval) {
        this.$nextTick(function () {
          var myEvent = new Event("resize");
          window.dispatchEvent(myEvent);
        });
      },
      deep: true
    },
    activeName(val) {
      this.$nextTick(function () {
        var myEvent = new Event("resize");
        window.dispatchEvent(myEvent);
      });
    },
    opened() {
      setTimeout(() => {
        this.setResize();
      }, 300)
    },
    Init(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.getEnergyList();
        });
        this.handleQuery();

      }
    }
  },

  methods: {
    setNullForOil(row, val) {
      let fuelTypeOil = this.$t("oiltype.caiyouji");//柴油
      // 油车，不显示电耗等，返回“--”
      if (row.fuelType == fuelTypeOil) {
        return "- -";
      } else {
        return parseFloat(Number(val).toFixed(2))
      }

    },
    setNullForEle(row, val) {
      // 电车，不显示油耗等，返回“--”
      let fuelTypeOil = this.$t("statistics.pureElectric");//柴油
      if (row.fuelType == fuelTypeOil) {
        return "- -";
      } else {
        return parseFloat(Number(val).toFixed(2))
      }
    },
    setResize() {
      if(this.chartAllOrSingle && this.exist_power_oil.isPower_Cpn){
        //电车全部
        if(this.chart_fleetConspt) this.chart_fleetConspt.resize();
        if(this.chart_fleetMileage) this.chart_fleetMileage.resize();
        if(this.chart_avgConspt) this.chart_avgConspt.resize();
      }
      if(this.chartAllOrSingle && this.exist_power_oil.isOil_Cpn){
        //油车全部
        if(this.chart_fleetOilConspt) this.chart_fleetOilConspt.resize();
        if(this.chart_fleetOilMileage) this.chart_fleetOilMileage.resize();
        if(this.chart_avgOilConspt) this.chart_avgOilConspt.resize();
      }
      if(!this.chartAllOrSingle && this.exist_power_oil.isPower){
        //电车单车
        if(this.chart_single_power) this.chart_single_power.resize();
      }
      if(!this.chartAllOrSingle && this.exist_power_oil.isOil){
        //油车单车
        if(this.chart_single_oil) this.chart_single_oil.resize();
      }
      // this.chart_conspt.resize();
    },
    sortChange(column) {
      console.log("排序", column.prop, column.order);
      // this.currentPage = 1; // 排序后返回第一页
      // this.dataList = this.dataList.sort(
      //   this.SortFun(column.prop, column.order === "descending")
      // );

      this.Params = column.prop;
      this.SortFlag = column.order == "ascending" ? 1 : column.order ? 2 : undefined;
      this.getList(1);
    },
    timeChange(s) {
      if (s == null || s == 0) return "0";
      let day, hour, minute, second;
      day = parseInt(s / 3600 / 24) == 0 ? "" : parseInt(s / 3600 / 24) + this.$t("statistics.day");
      hour = parseInt(s / 3600 % 24) == 0 ? "" : parseInt(s / 3600 % 24) + this.$t("time.hour");
      minute = parseInt(s / 60 % 60) == 0 ? "" : parseInt(s / 60 % 60) + this.$t("time.cent");
      second = parseInt(s % 60) == 0 ? "" : parseInt(s % 60) + this.$t("time.second");
      // console.log(s,day,hour,minute,second,);
      return day + hour + minute + second;
    },
    fuelTypeLanguages(row) {
      switch (row.fuelType) {
        case "柴油":
          return this.$t("statistics.dieselFuel");
        case "纯电动":
          return this.$t("statistics.pureElectric");
        default: return row.fuelType;
      }
    },
    getEnergyList() {
      this.loadingCharts = true;
      //获取能耗统计数据
      this.$api
        .energyStatistics({
          OperatorID: this.$store.getters.operator.OperatorId,
          SubjectCorpID: this.$store.getters.operator.CompanyId,
          queryType: this.type == "0" ? 2 : 1,
        })
        .then((res) => {
          if (res && res.code == 200) {
            this.fleetConsptChartData = res.data1.chartList;
            this.fleetMileageChartData = res.data2.chartList;
            this.avgConsptChartData = res.data3.chartList;
            //油车
            this.fleetOilConsptChartData = res.data4.chartList;
            this.fleetOilMileageChartData = res.data5.chartList;
            this.avgOilConsptChartData = res.data6.chartList;
            if (this.fleetConsptChartData && this.fleetConsptChartData.length > 0) {
              let xAxis_data = [];
              let yAxis_data = [];
              this.fleetConsptChartData.forEach(e => {
                xAxis_data.push(e.Date.substring(e.Date.length - 5));
                yAxis_data.push(e.Vaule);
                this.fleetConspt += e.Vaule;//Value
              });
              this.chart_fleetConspt.setOption({
                xAxis: [
                  {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                      color: "rgba(15,26,58,0.5)",
                      fontSize: 12
                    },
                    axisLine: {
                      lineStyle: {
                        color: "rgba(15,26,58,0.5)",
                      }
                    },
                    data: xAxis_data
                  }
                ],
                tooltip: {
                  trigger: 'axis',
                  position: function (point, params, dom, rect, size) {
                    // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
                    // 提示框位置
                    var x = 0; // x坐标位置
                    var y = 0; // y坐标位置

                    // 当前鼠标位置
                    var pointX = point[0];
                    var pointY = point[1];

                    // 提示框大小
                    var boxWidth = size.contentSize[0];
                    var boxHeight = size.contentSize[1];

                    // boxWidth > pointX 说明鼠标左边放不下提示框
                    if (boxWidth > pointX) {
                      x = 5;
                    } else { // 左边放的下
                      x = pointX - boxWidth;
                    }

                    // boxHeight > pointY 说明鼠标上边放不下提示框
                    if (boxHeight > pointY) {
                      y = 5;
                    } else { // 上边放得下
                      y = pointY - boxHeight;
                    }

                    return [x, y];
                  }
                },
                series: [
                  {
                    name: this.$t("statistics.fleetConspt"),
                    type: 'line',
                    smooth: true,
                    symbol: "none",
                    areaStyle: {
                      color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                          offset: 0, color: '#2A7AFF' // 0% 处的颜色
                        }, {
                          offset: 1, color: '#ffffff' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                      },
                    },
                    lineStyle: {
                      color: "#2A7AFF"
                    },
                    data: yAxis_data
                  },
                ]
              })
            }
            if (this.fleetMileageChartData && this.fleetMileageChartData.length > 0) {
              let xAxis_data = [];
              let yAxis_data = [];
              this.fleetMileageChartData.forEach(e => {
                xAxis_data.push(e.Date.substring(e.Date.length - 5));
                yAxis_data.push(e.Vaule);
                this.fleetMileage += e.Vaule;
              });
              this.fleetMileage = parseFloat(this.fleetMileage.toFixed(2));
              this.chart_fleetMileage.setOption({
                xAxis: [
                  {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                      color: "rgba(15,26,58,0.5)",
                      fontSize: 12
                    },
                    axisLine: {
                      lineStyle: {
                        color: "rgba(15,26,58,0.5)",
                      }
                    },
                    data: xAxis_data
                  }
                ],
                tooltip: {
                  trigger: 'axis',
                  position: function (point, params, dom, rect, size) {
                    // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
                    // 提示框位置
                    var x = 0; // x坐标位置
                    var y = 0; // y坐标位置

                    // 当前鼠标位置
                    var pointX = point[0];
                    var pointY = point[1];

                    // 提示框大小
                    var boxWidth = size.contentSize[0];
                    var boxHeight = size.contentSize[1];

                    // boxWidth > pointX 说明鼠标左边放不下提示框
                    if (boxWidth > pointX) {
                      x = 5;
                    } else { // 左边放的下
                      x = pointX - boxWidth;
                    }

                    // boxHeight > pointY 说明鼠标上边放不下提示框
                    if (boxHeight > pointY) {
                      y = 5;
                    } else { // 上边放得下
                      y = pointY - boxHeight;
                    }

                    return [x, y];
                  }
                },
                series: [
                  {
                    name: this.$t("statistics.fleetMileage"),
                    type: 'line',
                    smooth: true,
                    symbol: "none",
                    areaStyle: {
                      color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                          offset: 0, color: '#2A7AFF' // 0% 处的颜色
                        }, {
                          offset: 1, color: '#ffffff' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                      },
                    },
                    lineStyle: {
                      color: "#2A7AFF"
                    },
                    data: yAxis_data
                  },
                ]
              })
            }
            if (this.avgConsptChartData && this.avgConsptChartData.length > 0) {
              let xAxis_data = [];
              let yAxis_data = [];
              let avgSum = 0;
              this.avgConsptChartData.forEach(e => {
                xAxis_data.push(e.Date.substring(e.Date.length - 5));
                yAxis_data.push(e.Vaule);
                avgSum += e.Vaule;
              });
              // this.avgConspt = (avgSum / 7).toFixed(2);
              this.avgConspt = this.fleetMileage != 0 ? ((this.fleetConspt / this.fleetMileage) * 100).toFixed(2) : 0;
              this.chart_avgConspt.setOption({
                xAxis: [
                  {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                      color: "rgba(15,26,58,0.5)",
                      fontSize: 12
                    },
                    axisLine: {
                      lineStyle: {
                        color: "rgba(15,26,58,0.5)",
                      }
                    },
                    data: xAxis_data
                  }
                ],
                tooltip: {
                  trigger: 'axis',
                  position: function (point, params, dom, rect, size) {
                    // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
                    // 提示框位置
                    var x = 0; // x坐标位置
                    var y = 0; // y坐标位置

                    // 当前鼠标位置
                    var pointX = point[0];
                    var pointY = point[1];

                    // 提示框大小
                    var boxWidth = size.contentSize[0];
                    var boxHeight = size.contentSize[1];

                    // boxWidth > pointX 说明鼠标左边放不下提示框
                    if (boxWidth > pointX) {
                      x = 5;
                    } else { // 左边放的下
                      x = pointX - boxWidth;
                    }

                    // boxHeight > pointY 说明鼠标上边放不下提示框
                    if (boxHeight > pointY) {
                      y = 5;
                    } else { // 上边放得下
                      y = pointY - boxHeight;
                    }

                    return [x, y];
                  }
                },
                series: [
                  {
                    name: this.$t("statistics.avgConspt"),
                    type: 'line',
                    smooth: true,
                    symbol: "none",
                    areaStyle: {
                      color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                          offset: 0, color: '#2A7AFF' // 0% 处的颜色
                        }, {
                          offset: 1, color: '#ffffff' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                      },
                    },
                    lineStyle: {
                      color: "#2A7AFF"
                    },
                    data: yAxis_data
                  },
                ]
              })
            }


            if (this.fleetOilConsptChartData && this.fleetOilConsptChartData.length > 0) {
              let xAxis_data = [];
              let yAxis_data = [];
              this.fleetOilConsptChartData.forEach(e => {
                xAxis_data.push(e.Date.substring(e.Date.length - 5));
                yAxis_data.push(e.Vaule);
                this.fleetOilConspt += e.Vaule;//Value
              });
              this.chart_fleetOilConspt.setOption({
                xAxis: [
                  {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                      color: "rgba(15,26,58,0.5)",
                      fontSize: 12
                    },
                    axisLine: {
                      lineStyle: {
                        color: "rgba(15,26,58,0.5)",
                      }
                    },
                    data: xAxis_data
                  }
                ],
                tooltip: {
                  trigger: 'axis',
                  position: function (point, params, dom, rect, size) {
                    // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
                    // 提示框位置
                    var x = 0; // x坐标位置
                    var y = 0; // y坐标位置

                    // 当前鼠标位置
                    var pointX = point[0];
                    var pointY = point[1];

                    // 提示框大小
                    var boxWidth = size.contentSize[0];
                    var boxHeight = size.contentSize[1];

                    // boxWidth > pointX 说明鼠标左边放不下提示框
                    if (boxWidth > pointX) {
                      x = 5;
                    } else { // 左边放的下
                      x = pointX - boxWidth;
                    }

                    // boxHeight > pointY 说明鼠标上边放不下提示框
                    if (boxHeight > pointY) {
                      y = 5;
                    } else { // 上边放得下
                      y = pointY - boxHeight;
                    }

                    return [x, y];
                  }
                },
                series: [
                  {
                    name: this.$t("statistics.fleetOilConspt"),
                    type: 'line',
                    smooth: true,
                    symbol: "none",
                    areaStyle: {
                      color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                          offset: 0, color: '#2A7AFF' // 0% 处的颜色
                        }, {
                          offset: 1, color: '#ffffff' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                      },
                    },
                    lineStyle: {
                      color: "#2A7AFF"
                    },
                    data: yAxis_data
                  },
                ]
              })
            }
            if (this.fleetOilMileageChartData && this.fleetOilMileageChartData.length > 0) {
              let xAxis_data = [];
              let yAxis_data = [];
              this.fleetOilMileageChartData.forEach(e => {
                xAxis_data.push(e.Date.substring(e.Date.length - 5));
                yAxis_data.push(e.Vaule);
                this.fleetOilMileage += e.Vaule;
              });
              this.fleetOilMileage = parseFloat(this.fleetOilMileage.toFixed(2));
              this.chart_fleetOilMileage.setOption({
                xAxis: [
                  {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                      color: "rgba(15,26,58,0.5)",
                      fontSize: 12
                    },
                    axisLine: {
                      lineStyle: {
                        color: "rgba(15,26,58,0.5)",
                      }
                    },
                    data: xAxis_data
                  }
                ],
                tooltip: {
                  trigger: 'axis',
                  position: function (point, params, dom, rect, size) {
                    // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
                    // 提示框位置
                    var x = 0; // x坐标位置
                    var y = 0; // y坐标位置

                    // 当前鼠标位置
                    var pointX = point[0];
                    var pointY = point[1];

                    // 提示框大小
                    var boxWidth = size.contentSize[0];
                    var boxHeight = size.contentSize[1];

                    // boxWidth > pointX 说明鼠标左边放不下提示框
                    if (boxWidth > pointX) {
                      x = 5;
                    } else { // 左边放的下
                      x = pointX - boxWidth;
                    }

                    // boxHeight > pointY 说明鼠标上边放不下提示框
                    if (boxHeight > pointY) {
                      y = 5;
                    } else { // 上边放得下
                      y = pointY - boxHeight;
                    }

                    return [x, y];
                  }
                },
                series: [
                  {
                    name: this.$t("statistics.fleetOilMileage"),
                    type: 'line',
                    smooth: true,
                    symbol: "none",
                    areaStyle: {
                      color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                          offset: 0, color: '#2A7AFF' // 0% 处的颜色
                        }, {
                          offset: 1, color: '#ffffff' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                      },
                    },
                    lineStyle: {
                      color: "#2A7AFF"
                    },
                    data: yAxis_data
                  },
                ]
              })
            }
            if (this.avgOilConsptChartData && this.avgOilConsptChartData.length > 0) {
              let xAxis_data = [];
              let yAxis_data = [];
              let avgOilSum = 0;
              this.avgOilConsptChartData.forEach(e => {
                xAxis_data.push(e.Date.substring(e.Date.length - 5));
                yAxis_data.push(e.Vaule);
                avgOilSum += e.Vaule;
              });
              // this.avgConspt = (avgSum / 7).toFixed(2);
              this.avgOilConspt = this.fleetOilMileage != 0 ? ((this.fleetOilConspt / this.fleetOilMileage) * 100).toFixed(2) : 0;
              this.chart_avgOilConspt.setOption({
                xAxis: [
                  {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                      color: "rgba(15,26,58,0.5)",
                      fontSize: 12
                    },
                    axisLine: {
                      lineStyle: {
                        color: "rgba(15,26,58,0.5)",
                      }
                    },
                    data: xAxis_data
                  }
                ],
                tooltip: {
                  trigger: 'axis',
                  position: function (point, params, dom, rect, size) {
                    // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
                    // 提示框位置
                    var x = 0; // x坐标位置
                    var y = 0; // y坐标位置

                    // 当前鼠标位置
                    var pointX = point[0];
                    var pointY = point[1];

                    // 提示框大小
                    var boxWidth = size.contentSize[0];
                    var boxHeight = size.contentSize[1];

                    // boxWidth > pointX 说明鼠标左边放不下提示框
                    if (boxWidth > pointX) {
                      x = 5;
                    } else { // 左边放的下
                      x = pointX - boxWidth;
                    }

                    // boxHeight > pointY 说明鼠标上边放不下提示框
                    if (boxHeight > pointY) {
                      y = 5;
                    } else { // 上边放得下
                      y = pointY - boxHeight;
                    }

                    return [x, y];
                  }
                },
                series: [
                  {
                    name: this.$t("statistics.avgOilConspt"),
                    type: 'line',
                    smooth: true,
                    symbol: "none",
                    areaStyle: {
                      color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                          offset: 0, color: '#2A7AFF' // 0% 处的颜色
                        }, {
                          offset: 1, color: '#ffffff' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                      },
                    },
                    lineStyle: {
                      color: "#2A7AFF"
                    },
                    data: yAxis_data
                  },
                ]
              })
            }



            this.loadingCharts = false;
          }
        })
        .catch((res) => {
          this.loadingCharts = false;
        })
    },
    secondsToHMS(seconds) {
      // 计算小时
      const hours = Math.floor(seconds / 3600);
      // 计算分钟
      const minutes = Math.floor((seconds % 3600) / 60);
      // 计算秒钟
      const secs = seconds % 60;

      // 格式化小时、分钟和秒钟
      const formattedHours = hours.toString().padStart(2, '0');
      const formattedMinutes = minutes.toString().padStart(2, '0');
      const formattedSecs = secs.toString().padStart(2, '0');

      return `${formattedHours}:${formattedMinutes}:${formattedSecs}`;
    },
    getSelectedVehicles() {
      this.vehicles = "";
      for (let k = 0; k < this.selectedVehicles.length; k++) {
        if (this.selectedVehicles[k].treeLevel == 5) {
          this.vehicles = this.vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return this.vehicles.substring(0, this.vehicles.length - 1);
    },
    handleQuery(e) {
      var isInit = this.searchMTime[0] instanceof Date && !isNaN(this.searchMTime[0].getTime());
      this.beginDate =
        (this.searchDTime != null || this.searchMTime != null) && (this.searchDTime[0] != undefined || this.searchMTime[0] != undefined)
          ? (this.activeName == "first" ? (isInit ? this.format(this.searchMTime[0], "yyyy-MM-01") : this.searchMTime[0] + "-01") : this.format(this.searchDTime[0], "yyyy-MM-dd"))
          : "";
      this.endDate =
        (this.searchDTime != null || this.searchMTime != null) && (this.searchDTime[1] != undefined || this.searchMTime[1] != undefined)
          ? (this.activeName == "first" ? (isInit ? this.format(this.searchMTime[1], "yyyy-MM" + "-" + this.getCountDays(this.searchMTime[1])) : this.searchMTime[1] + "-" + this.getCountDays(this.searchMTime[1])) : this.format(this.searchDTime[1], "yyyy-MM-dd"))
          : "";
      // console.log(this.beginDate,this.endDate);
      this.vehicles = this.getSelectedVehicles();
      this.isAllVehicles = this.vehicles == "" ? true : this.vehicles.split(",").length == this.tree[this.$store.getters.operator.CompanyId].totalCount;
      this.currentPage = 1;
      this.$refs.table.clearSort();
      this.SortFlag = undefined;//清空排序条件
      this.getList();

    },
    // 获取是否存在油车、电车
    getCarType(val) {
      //val 车辆类型数组 1 柴油 2 气体机 3 油电 4 气电 5 纯电动  6 燃料电池
      let power;
      let oil;
      let isPower;
      let isOil;
      power = val.filter((e) => {
        return e == 5;
      });
      oil = val.filter((e) => {
        return e == 1;
      })
      this.exist_power_oil.isPower = power.length >= 1 ? true : false;
      this.exist_power_oil.isOil = oil.length >= 1 ? true : false;
    },
    //获取公司是否存在油车、电车
    getCpnCarType() {
      // 1 柴油 2 气体机 3 油电 4 气电 5 纯电动  6 燃料电池
      let selectVehType = [];
      let power;
      let oil;
      let timeOut = 0;
      timeOut = this.appVehicles.data.length == 0 ? 1 : 0;
      setTimeout(() => {
        for (var item = 0; item < this.appVehicles.data.length; item++) {
          if (this.appVehicles.data[item].treeLevel == 5) {
            selectVehType.push(this.appVehicles.data[item].oilTypeID_New);
          }
        }
        // console.log(this.appVehicles.data);
        power = selectVehType.filter((e) => {
          return e == 5;
        });
        oil = selectVehType.filter((e) => {
          return e == 1;
        })
        this.exist_power_oil.isPower_Cpn = power.length >= 1 ? true : false;
        this.exist_power_oil.isOil_Cpn = oil.length >= 1 ? true : false;
      }, timeOut)
    },
    setChart() {
      // console.log("设置上面的折线图");
      var xAxis_data = [];
      var yAxis_data_power = [];
      var yAxis_data_oil = [];
      var selectVeh = [];//选择的车号
      var selectVehType = [];//选择的车号的类型，油车/电车
      var series_power = [];//折线图数据配置
      var series_oil = [];//折线图数据配置
      var legend_power = [];//折线图线配置
      var legend_oil = [];//折线图线配置
      this.chartAllOrSingle = (this.vehicles == "" || this.vehicles.length == this.allVehicles.length) ? true : false;//全选时展示车队图表信息，否则展示单车信息
      for (let k = 0; k < this.selectedVehicles.length; k++) {
        if (this.selectedVehicles[k].treeLevel == 5) {
          selectVehType.push(this.selectedVehicles[k].oilTypeID_New);
          selectVeh.push(this.selectedVehicles[k].vehicleName);
        }
      }
      this.getCarType(selectVehType);
      if (!this.chartAllOrSingle) {
        for (let i = 0; i < selectVeh.length; i++) {
          // yAxis_data.push([]);
          // series.push([]);
          // legend.push(selectVeh[i]);

          //分油车/电车两个图
          switch (selectVehType[i]) {
            case 1://柴油
              yAxis_data_oil.push([]);
              series_oil.push([]);
              legend_oil.push(selectVeh[i]);

              break;
            case 5://纯电动
              yAxis_data_power.push([]);
              series_power.push([]);
              legend_power.push(selectVeh[i]);
              break;
          }
        }
        this.dataList.forEach((e) => {
          if (!xAxis_data.includes(e.statisticalTime)) {
            xAxis_data.push(e.statisticalTime);
          }
          xAxis_data.sort();
        })

        // 获取油车数据
        for (let i = 0; i < legend_oil.length; i++) {
          let item = 0  //
          let y_oil = yAxis_data_oil[i];
          tiaochu: for (let dt = 0; dt < this.dataList.length; dt++) {  //遍历dataList数据，找跟x坐标时间对应的数据，一个车号在一个时间只有一条数据(一对一对一关系)
            if (this.dataList[dt].carNo == legend_oil[i]) {   //锁定车号，找时间点对应--数据
              for (item; item < xAxis_data.length;) {   //根据时间为x坐标来push添加对应时间点的y轴数据
                if (xAxis_data[item] == this.dataList[dt].statisticalTime) {
                  y_oil.push(this.dataList[dt].oilConsumption);
                  item = item + 1;
                  //  continue;
                  continue tiaochu;  //一个车号在一个时间点只有一个数据，找到后说明应该往datalist的下一条数据继续找下一个时间点的对应数据
                  //如果不跳出，会用该已经找到的dataList继续往下找时间点，但dataList和时间点是一对一关系，就会进入else语句，添加进0的无用数据
                }
                else {
                  y_oil.push(0);
                  item = item + 1;  //不跳出，因为该条dataList数据还没找到对应时间点，应在时间里继续遍历找对应时间点
                  // continue;
                  // continue tiaochu;
                }
              }
            }
          }
          series_oil[i] = {
            name: legend_oil[i],
            type: 'line',
            smooth: true,
            data: yAxis_data_oil[i],
          }
        }
        // 获取电车
        for (let i = 0; i < legend_power.length; i++) {
          let item = 0  //
          let y_power = yAxis_data_power[i];
          tiaochu: for (let dt = 0; dt < this.dataList.length; dt++) {  //遍历dataList数据，找跟x坐标时间对应的数据，一个车号在一个时间只有一条数据(一对一对一关系)
            if (this.dataList[dt].carNo == legend_power[i]) {   //锁定车号，找时间点对应--数据
              for (item; item < xAxis_data.length;) {   //根据时间为x坐标来push添加对应时间点的y轴数据
                if (xAxis_data[item] == this.dataList[dt].statisticalTime) {
                  y_power.push(this.dataList[dt].powerConsumption);
                  item = item + 1;
                  //  continue;
                  continue tiaochu;  //一个车号在一个时间点只有一个数据，找到后说明应该往datalist的下一条数据继续找下一个时间点的对应数据
                  //如果不跳出，会用该已经找到的dataList继续往下找时间点，但dataList和时间点是一对一关系，就会进入else语句，添加进0的无用数据
                }
                else {
                  y_power.push(0);
                  item = item + 1;  //不跳出，因为该条dataList数据还没找到对应时间点，应在时间里继续遍历找对应时间点
                  // continue;
                  // continue tiaochu;
                }
              }
            }
          }
          series_power[i] = {
            name: legend_power[i],
            type: 'line',
            smooth: true,
            data: yAxis_data_power[i],
          }
        }
        this.chart_single_oil.setOption({
          grid: {
            left: 10,
            right: 32,
            bottom: 0,
            top: 45,
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            position: function (point, params, dom, rect, size) {
              // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
              // 提示框位置
              var x = 0; // x坐标位置
              var y = 0; // y坐标位置
              // 当前鼠标位置
              var pointX = point[0];
              var pointY = point[1];
              // 提示框大小
              var boxWidth = size.contentSize[0];
              var boxHeight = size.contentSize[1];
              // boxWidth > pointX 说明鼠标左边放不下提示框
              if (boxWidth > pointX) {
                x = 5;
              } else { // 左边放的下
                x = pointX - boxWidth;
              }
              // boxHeight > pointY 说明鼠标上边放不下提示框
              if (boxHeight > pointY) {
                y = 5;
              } else { // 上边放得下
                y = pointY - boxHeight;
              }
              return [x, y];
            }
          },
          title: {
            left: 'center',
            text: this.$t("statistics.oilConsume")
          },
          xAxis: [
            {
              type: 'category',
              data: xAxis_data
            }
          ],
          yAxis: {
            type: 'value',
          },
          series: series_oil,
          legend: {
            show: true,
            top: "10%",
            data: legend_oil
          },
        }, true);
        this.chart_single_power.setOption({
          grid: {
            left: 10,
            right: 32,
            bottom: 0,
            top: 45,
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            position: function (point, params, dom, rect, size) {
              // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
              // 提示框位置
              var x = 0; // x坐标位置
              var y = 0; // y坐标位置
              // 当前鼠标位置
              var pointX = point[0];
              var pointY = point[1];
              // 提示框大小
              var boxWidth = size.contentSize[0];
              var boxHeight = size.contentSize[1];
              // boxWidth > pointX 说明鼠标左边放不下提示框
              if (boxWidth > pointX) {
                x = 5;
              } else { // 左边放的下
                x = pointX - boxWidth;
              }
              // boxHeight > pointY 说明鼠标上边放不下提示框
              if (boxHeight > pointY) {
                y = 5;
              } else { // 上边放得下
                y = pointY - boxHeight;
              }
              return [x, y];
            }
          },
          title: {
            left: 'center',
            text: this.$t("statistics.powerConsumption")
          },
          xAxis: [
            {
              type: 'category',
              data: xAxis_data
            }
          ],
          yAxis: {
            type: 'value',
          },
          series: series_power,
          legend: {
            show: true,
            top: "10%",
            data: legend_power
          },
        }, true);
      }
    },
    getList(resetChart) {
      this.loading = true;
      this.$api
        .energyInfo({
          companyID: this.$store.getters.operator.CompanyId,
          vehicles: this.vehicles,//"100738",
          queryType: this.activeName == "first" ? 0 : 1,
          beginDate: this.beginDate,
          endDate: this.endDate,
          OperatorID: this.$store.getters.operator.OperatorId,

          PageNo: this.isAllVehicles ? this.currentPage : 1,
          PageSize: this.isAllVehicles ? 10 : 1000,
          IsExport: 0, // 0是查询 1是下载
          Language: this.LanguageId,
          Params: this.SortFlag ? this.Params : this.isAllVehicles ? this.defalteQuery.Params : undefined,
          SortFlag: this.SortFlag ? this.SortFlag : this.isAllVehicles ? this.defalteQuery.SortFlag : undefined,
          CompanyFlag: 0,
        })
        .then((res) => {
          if (res && res.code == 200) {
            this.loading = false;
            this.dataList = res.data;
            this.total = res.recordsTotal;

            resetChart ? null : this.setChart(this.dataList);

            if (this.total == 0) {
              this.$message.info(this.$t("statistics.noData"));
            }
          }
        })
        .catch((e) => {
          this.loading = false;
        })
    },
    download() {

      this.vehicles = this.getSelectedVehicles();
      var that = this;
      that.downloading = true;
      this.$api
        .downEnergyInfo({
          companyID: this.$store.getters.operator.CompanyId,
          vehicles: this.vehicles,//"100738",
          queryType: this.activeName == "first" ? 0 : 1,
          beginDate: this.beginDate,
          endDate: this.endDate,
          OperatorID: this.$store.getters.operator.OperatorId,
          IsExport: 1, // 0是查询 1是下载
          Language: this.LanguageId,
          CompanyFlag: 0,
        })
        .then((res) => {
          let blob = new Blob([res], {
            type: "application/vnd.ms-excel;charset=utf-8",
          }); // 重点代码
          let a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.setAttribute(
            "download",
            that.type == "0" ? that.$t("statistics.月燃耗") + that.$t("public.download") + `_${that.timestampToTime(new Date().getTime())}.xlsx`
              : that.$t("statistics.日燃耗") + that.$t("public.download") + `_${that.timestampToTime(new Date().getTime())}.xlsx`
          ); // 表名，自定义
          a.click(); // 执行下载
          window.URL.revokeObjectURL(blob); // 释放ur
          that.downloading = false;
        })
        .catch((error) => {
          console.error("下载失败", error);
          that.downloading = false;
        });
    },
    //时间戳转换为日期格式
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间数为10位篇*1000，时间数为13位的话不需乘1000
      var Y = date.getFullYear();
      var M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var D = date.getDate();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      return Y + M + D + h + m + s;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j == "fuelType") {
          switch (v[j]) {
            case "柴油":
              return this.$t("statistics.dieselFuel");
              break;
            case "纯电动":
              return this.$t("statistics.pureElectric");
              break;
            default: break;
          };
        } else if (j == "runTime") {
          return this.timeChange(v[j]);
        } else if (j == "utilization") {
          return v[j] == 0 ? v[j] : v[j] + "%";
        } else if (j == "powerConsumptionPer100km") {
          return this.toFixed2(v[j]);
        } else if (j == "oilConsumptionPer100km") {
          return this.toFixed2(v[j]);
        } else {
          return v[j]
        }
      }))
    },
    toFixed2(val) {
      if (Number.isInteger(val)) return val;
      return val.toFixed(2);
    },
    quickQuery(val) {
      if (this.activeName == "first") {
        this.showMBtn = val
      } else this.showDBtn = val;
      let day = 24 * 60 * 60 * 1000;
      let getDay = new Date().getDay();
      let getNowMonth = new Date().getMonth() + 1 + "";
      getNowMonth = getNowMonth.length == 2 ? getNowMonth : ("00" + getNowMonth).substring(("" + getNowMonth).length);
      let getLastMonth = new Date().getMonth() + "";
      getLastMonth = getLastMonth.length == 2 ? getLastMonth : ("00" + getLastMonth).substring(("" + getLastMonth).length);
      let today = new Date();
      if (this.activeName == "first") {
        switch (val) {
          case 0: //本月
            this.beginDate = this.format(new Date(), "yyyy-" + getNowMonth + "-01");
            this.endDate = this.format(new Date(), "yyyy-" + getNowMonth + "-" + this.getCountDays(this.beginDate));
            // console.log(this.beginDate,this.endDate);
            break;
          case 1:  //上月
            //跨年特殊处理
            if (getLastMonth == "00") {
              this.beginDate = this.format(new Date(), today.getFullYear() - 1 + "-12-01");
              this.endDate = this.format(new Date(), today.getFullYear() - 1 + "-12-31");
            } else {
              this.beginDate = this.format(new Date(), "yyyy-" + getLastMonth + "-01");
              this.endDate = this.format(new Date(), "yyyy-" + getLastMonth + "-" + this.getCountDays(this.beginDate));
            }
            // console.log(this.beginDate,this.endDate);
            break;
          case 2:  //上上月
            let month = new Date().getMonth() - 1 + "";
            month = month.length == 2 ? month : ("00" + month).substring(("" + month).length);
            //跨年特殊处理
            if (month == "-1") {
              this.beginDate = this.format(new Date(), today.getFullYear() - 1 + "-11-01");
              this.endDate = this.format(new Date(), today.getFullYear() - 1 + "-11-30");
            } else if (month == "00") {
              this.beginDate = this.format(new Date(), today.getFullYear() - 1 + "-12-01");
              this.endDate = this.format(new Date(), today.getFullYear() - 1 + "-12-31");
            } else {
              this.beginDate = this.format(new Date(), "yyyy-" + month + "-01");
              this.endDate = this.format(new Date(), "yyyy-" + month + "-" + this.getCountDays(this.beginDate));
            }
            // console.log(this.beginDate,this.endDate);
            break;
        }
      }
      else {
        switch (val) {
          case 0:
            //跨年特殊处理
            if (getLastMonth == "00") {
              this.beginDate = this.format(new Date(), today.getFullYear() - 1 + "-12-01");
              this.endDate = this.format(new Date(), today.getFullYear() - 1 + "-12-31");
            } else {
              this.beginDate = this.format(new Date(), "yyyy-" + getLastMonth + "-01");
              this.endDate = this.format(new Date(new Date(this.beginDate).getTime() + (this.getCountDays(this.beginDate) - 1) * day), "yyyy-MM-dd");
            }
            // console.log(this.beginDate,this.endDate);
            break;
          case 1:  //本月
            this.beginDate = this.format(new Date(), "yyyy-" + getNowMonth + "-01");
            this.endDate = this.format(new Date(new Date().getTime()), "yyyy-MM-dd");
            // console.log(this.beginDate,this.endDate);
            break;
          case 2:
            this.beginDate = this.format(new Date(new Date().getTime() - (getDay + 6) * day), "yyyy-MM-dd");
            this.endDate = this.format(new Date(new Date().getTime() - getDay * day), "yyyy-MM-dd");
            // console.log(this.beginDate,this.endDate);
            break;
          case 3:
            this.beginDate = this.format(new Date(new Date().getTime() - (getDay - 1) * day), "yyyy-MM-dd");
            this.endDate = this.format(new Date(new Date().getTime()), "yyyy-MM-dd");
            // console.log(this.beginDate,this.endDate);
            break;
          case 4://前天
            this.beginDate = this.format(new Date(new Date().getTime() - 2 * day), "yyyy-MM-dd");
            this.endDate = this.format(new Date(new Date().getTime() - 2 * day), "yyyy-MM-dd");
            // console.log(this.beginDate,this.endDate);
            break;
          case 5:
            this.beginDate = this.format(new Date(new Date().getTime() - day), "yyyy-MM-dd");
            this.endDate = this.format(new Date(new Date().getTime() - day), "yyyy-MM-dd")
            // console.log(this.beginDate,this.endDate);
            break;
          case 6:
            this.beginDate = this.format(new Date(), "yyyy-MM-dd");
            this.endDate = this.format(new Date(new Date().getTime()), "yyyy-MM-dd");
            // console.log(this.beginDate,this.endDate);
            break;
        }
      }

      this.vehicles = this.getSelectedVehicles();
      this.isAllVehicles = this.vehicles == "" ? true : this.vehicles.split(",").length == this.tree[this.$store.getters.operator.CompanyId].totalCount;
      this.currentPage = 1;
      this.$refs.table.clearSort();
      this.SortFlag = undefined;//清空排序条件
      this.getList();
    },
    format(datetime, format) {
      var o = {
        "M+": datetime.getMonth() + 1, //month
        "d+": datetime.getDate(), //day
        "h+": datetime.getHours(), //hour
        "m+": datetime.getMinutes(), //minute
        "s+": datetime.getSeconds(), //second
        "q+": Math.floor((datetime.getMonth() + 3) / 3), //quarter
        S: datetime.getMilliseconds(), //millisecond
      };
      if (/(y+)/.test(format)) {
        format = format.replace(
          /(y+)/.exec(format)[0],
          (datetime.getFullYear() + "").substring(4 - /(y+)/.exec(format)[0].length)
        );
      }

      for (var k in o) {
        // console.log(o[k]);
        if (new RegExp("(" + k + ")").test(format)) {
          let item = eval("/(" + k + ")/.exec(format)[0]")
          format = format.replace(
            item,
            item.length == 1 ? o[k] : ("00" + o[k]).substring(("" + o[k]).length)
          );
          // console.log(format,"0.0");
        }
      }
      return format;
    },
    // 获取一个月有多少天，curDate是开始日期，获取这个日期的月份的天数
    getCountDays(curDate) {
      const d = new Date(curDate)
      const y = d.getFullYear()
      //获取本月的下一个月
      const m = d.getMonth() + 1
      // 下一个月的第0天就是这个月的天数
      const days = new Date(y, m, 0).getDate()
      return days
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.isAllVehicles) {
        this.getList();
      }
      this.$refs.table.doLayout();//对 Table 进行重新布局。
    },
    fold() {
      this.showChartConspt = !this.showChartConspt;
      // if(this.showChartConspt){
      //   this.$nextTick(function () {
      //     var myEvent = new Event("resize");
      //     window.dispatchEvent(myEvent);
      //   });
      // }
      if (this.showChartConspt) {
        setTimeout(() => {
          var myEvent = new Event("resize");
          window.dispatchEvent(myEvent);
        }, 0)

      }
    },
    StatisticalMethod(val) {
    },
    report(val) {
      // console.log(val);
      if (this.radio1 == "总计") {
        switch (val) {
          case (val == "小时"):
            break;
          case (val == "日报"):
            break;
          case (val == "周报"):
            break;
          case (val == "月报"):
            break;
        }
        console.log("总计", val);
      }
      else {
        console.log("平均");
      }
    },
    initChart() {
      this.chart_fleetConspt = echarts.init(document.getElementById("chart_fleetConspt" + this.type));
      this.chart_fleetMileage = echarts.init(document.getElementById("chart_fleetMileage" + this.type));
      this.chart_avgConspt = echarts.init(document.getElementById("chart_avgConspt" + this.type));
      this.chart_fleetOilConspt = echarts.init(document.getElementById("chart_fleetOilConspt" + this.type));
      this.chart_fleetOilMileage = echarts.init(document.getElementById("chart_fleetOilMileage" + this.type));
      this.chart_avgOilConspt = echarts.init(document.getElementById("chart_avgOilConspt" + this.type));
      // this.chart_conspt = echarts.init(document.getElementById("chart_conspt"+this.type));
      this.chart_single_power = echarts.init(document.getElementById("chart_single_power" + this.type));
      this.chart_single_oil = echarts.init(document.getElementById("chart_single_oil" + this.type));

      var option = {
        grid: {
          left: 16,
          right: 16,
          bottom: '3%',
          top: 2,
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLabel: {
              color: "rgba(15,26,58,0.5)",
              fontSize: 12
            },
            axisLine: {
              lineStyle: {
                color: "rgba(15,26,58,0.5)",
              }
            },
            data: []
          }
        ],
        yAxis: [
          {
            show: false,
            axisLine: {
              show: false
            },
            type: 'value',
            axisTick: {
              show: false,  //刻度线
            },
            axisLabel: {
              show: false, //隐藏刻度值
            },
          }
        ],
        series: [
          {
            name: 'Email',
            type: 'line',
            // stack: 'Total',
            smooth: true,
            symbol: "none",
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#2A7AFF' // 0% 处的颜色
                }, {
                  offset: 1, color: '#ffffff' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              },

            },
            lineStyle: {
              color: "#2A7AFF"
            },
            data: []
          },
        ]
      };
      var optionSingle = {
        grid: {
          left: 30,
          right: 32,
          bottom: 0,
          top: 45,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          position: function (point, params, dom, rect, size) {
            // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
            // 提示框位置
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置

            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];

            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];

            // boxWidth > pointX 说明鼠标左边放不下提示框
            if (boxWidth > pointX) {
              x = 5;
            } else { // 左边放的下
              x = pointX - boxWidth;
            }

            // boxHeight > pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else { // 上边放得下
              y = pointY - boxHeight;
            }

            return [x, y];
          }
        },
        title: {
          left: 'center',
          text: '耗电量(度)'
        },
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            type: 'line',
            smooth: true,
            data: []
          }
        ]
      }

      this.chart_fleetConspt.setOption(option);
      this.chart_fleetMileage.setOption(option);
      this.chart_avgConspt.setOption(option);
      this.chart_fleetOilConspt.setOption(option);
      this.chart_fleetOilMileage.setOption(option);
      this.chart_avgOilConspt.setOption(option);
      this.chart_single_power.setOption(optionSingle);
      this.chart_single_oil.setOption(optionSingle);

    }
  },
  created() {
    this.winHeight = window.innerHeight;
    if (this.winHeight < 830) {
      this.showChartConspt = false;
    }
  },
  mounted() {
      const currentPath = this.$route.path
    // 从全局变量中取出对应路由的开始时间
    const startTime = settings.routeStartTime[currentPath]
    if (startTime) {
      // 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
      const renderTime = Date.now() - startTime
      console.log(`路由 ${currentPath} 渲染耗时：${renderTime}`)
      // 可选：上报到后端或日志系统
      // reportRenderTime(currentPath, renderTime)

      // 清除已计算的开始时间，避免重复计算
      delete settings.routeStartTime[currentPath]
    }
    this.LanguageId = language(this.$store.getters.locale)
    let t = new Date();
    var n = new Date(t.getFullYear(), t.getMonth() - 2, 1);
    this.searchMTime = [new Date(n), new Date];
    this.$nextTick(() => {
      this.initChart();
      this.getCpnCarType();
      // this.getEnergyList();
      this.setResize();
    });
    window.addEventListener('resize', this.setResize);
    this.options = [
      {
        value: 0,
        label: this.$t("time.generalQuery")
      },
      {
        value: 1,
        label: this.$t("time.quickQuery"),
      }
    ];
    this.monthBtns = [
      {
        value: 0,
        label: this.$t("time.thisMonth"),
      },
      {
        value: 1,
        label: this.$t("time.lastMonth"),
      },
      {
        value: 2,
        label: this.$t("time.twoMonthsGgo"),
      },
    ];
    this.dayBtns = [
      {
        value: 0,
        label: this.$t("time.lastMonth")
      },
      {
        value: 1,
        label: this.$t("time.thisMonth")
      },
      {
        value: 2,
        label: this.$t("time.lastWeek")
      },
      {
        value: 3,
        label: this.$t("time.thisWeek")
      },
      {
        value: 4,
        label: this.$t("time.beforyesterday")
      },
      {
        value: 5,
        label: this.$t("time.yesterday")
      },
      // {
      //   value:6,
      //   label:this.$t("time.today")
      // },
    ];
    for (var item = 0; item < this.appVehicles.data.length; item++) {
      if (this.appVehicles.data[item].treeLevel == 5) {
        // i++;
        this.allVehicles = this.allVehicles + this.appVehicles.data[item].nodeValue + ",";
      }
    }
    this.allVehicles = this.allVehicles.substring(0, this.allVehicles.length - 1);
    if (this.Init) {
      this.handleQuery();
      this.$nextTick(() => {
        this.getEnergyList();
      });
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.setResize)
  },
  activated(){
    this.setResize();
    window.addEventListener('resize',this.setResize)
  },
  deactivated(){
    window.removeEventListener('resize', this.setResize)
  },
}
</script>

<style lang="scss" scoped>
.el-card {
  background-color: transparent;
}

.pagination {

  ::v-deep .el-pagination button:disabled,
  .el-pager li,
  .el-pagination .btn-prev,
  .el-pagination .btn-next {
    background-color: transparent !important;
  }

}

.container {
  ::v-deep .el-table tr {
    background: transparent;
  }

  ::v-deep .el-table {
    background: transparent;
  }

  ::v-deep .el-table td {
    background: transparent;
  }
}

.iconfont {
  font-size: 10px;
}

.foldBtn {
  ::v-deep .el-button--mini {
    padding: 5px 10px !important;
  }
}

.pcVal {
  font-size: 15px;
  font-weight: bold;
}

.comptVal {
  font-size: 24px;
  margin-right: 5px;
  font-weight: bold;
}

.card ::v-deep {
  .el-card__header {
    /* background: #E8F0FF; */
    /* height: 35px; */
    padding: 15px 9px;
    /* font-weight: bold; */
    font-size: 14px;
  }

  .el-card__body {
    padding: 0;
  }

}

.el-icon-top:before {
  color: red;
  font-size: 24px;
  font-weight: bold;
}


.el-range-editor.el-input__inner {
  padding: 3px 5px;
}

.tabs {
  ::v-deep .el-tabs__item {
    padding: 0 10px !important;
    font-weight: bold;
    font-size: 14px;
  }

  ::v-deep .el-tabs__nav-wrap {
    &::after {
      display: none;
    }
  }

  ::v-deep .el-tabs__header {
    margin: 0;
  }

  ::v-deep .el-tabs__active-bar {
    height: 3px;
    border-radius: 2px;
  }
}

.el-form-item {
  margin-bottom: 0px !important;
}

 
</style>